var map = {
	"./Artboard 1.png": 1949,
	"./Flip R text.png": 9515,
	"./Macaw.png": 4850,
	"./abstract-01.png": 3382,
	"./among us.png": 6514,
	"./ball-cyber.png": 2995,
	"./bot.png": 216,
	"./corona earth 1-01-01.png": 6850,
	"./corona earth 2-01.png": 9213,
	"./corona earth 3-01.png": 5624,
	"./floral rk-02.png": 7850,
	"./golden-ball.png": 6777,
	"./m24 pubg.png": 3007,
	"./me.png": 9169,
	"./mountain.png": 4634,
	"./nishan.png": 4267,
	"./paper-cutout.png": 2912,
	"./plane 2.png": 7431,
	"./pom pom 2-01-01.png": 5866,
	"./pom pom 2-01.png": 251,
	"./scene-spring.png": 9640,
	"./scene-summer.png": 3977,
	"./scene-winter.png": 819
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 138;